var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftRightDash = function SvgLeftRightDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M6.25 5a.625.625 0 0 1 .625-.625h10a.625.625 0 1 1 0 1.25h-10A.625.625 0 0 1 6.25 5m10.625 4.375h-10a.625.625 0 0 0 0 1.25h10a.624.624 0 1 0 0-1.25m0 5h-10a.625.625 0 1 0 0 1.25h10a.624.624 0 1 0 0-1.25M3.438 4.063a.937.937 0 1 0 0 1.874.937.937 0 0 0 0-1.875m0 5a.937.937 0 1 0 0 1.874.937.937 0 0 0 0-1.874m0 5a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.876"
  })));
};
export default SvgLeftRightDash;